<template>
    <div>
      <header-sales></header-sales>
  
      <div id= "subheader"> </div> 

      <div id= "main-container"> 
        <div id= "label-container">
          <span id="label">Cuenta Corriente</span>
        </div> 
        <div id= "container">

          <div id="listMenu-container">
            <div id="listMenu-containerL">
              <input id="busqueda" type="text" placeholder="Buscar..." v-model="txtBusqueda" v-on:keyup="onKeyDownHandler"> 
            </div>  
            <div id="listMenu-containerR">
              <img  id="iconDownload" class="icon" @click= "btnDownload"  src="/dist/icon-download.png" title="descargar"/>   
              <img  id="iconDelete"   class="icon" @click= "btnDelete"  src="/dist/icon-delete-cc.png" title="eliminar"/>   
            </div>  
          </div>

          <div id="headerList-container">
            <div id="headerList-check" class="checkContainer" style="width: 6%"> <input type="checkbox" @change="checkAllEvent"> </div>
            <div id="headerList-comprobante" class="textHeaderList" style="width: 22%"># COMPROBANTE</div>
            <div id="headerList-tipo" class="textHeaderList" style="width: 8%">TIPO</div>
            <div id="headerList-fecha" class="textHeaderList" style="width: 14%">FECHA</div>
            <div id="headerList-vencimiento" class="textHeaderList" style="width: 14%">VENCIMIENTO</div>
            <div id="headerList-monto" class="textHeaderList" style="width: 15%">MONTO</div>
            <div id="headerList-saldo" class="textHeaderList" style="width: 15%">SALDO</div>
            <div id="headerList-ver" class="textHeaderList" style="width: 6%">VER</div>
          </div>

          <div  class="separator" style="width: 100%; height: 1px; background-color: #dddddd;" >  </div>

          <div id="list-container">
            <item-cc id="list-prod" v-for="item in items" :item='item' @checkItem="itemChecked" ref="itemCC"></item-cc>
          </div>

        </div> 
      </div> 
  
    </div>
  </template>
  
  
  
  <script>

    import HeaderSales from '@components/views/header.vue';
    import ItemCuentaCorriente from '@components/views/cuentaCorriente/itemCuentaCorriente.vue';

    export default {
      name: 'CuentaCorriente',
      components:{
       'header-sales': HeaderSales,
       'item-cc': ItemCuentaCorriente
      },


      data() {
          return {
            txtBusqueda:'', 
            checked : false,
            comprobChecked:[],
            items:[{'id':1,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':2,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},        
                   {'id':3,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':4,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':-456789.21},
                   {'id':5,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':-456789.21},
                   {'id':6,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':0.00},
                   {'id':7,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':8,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':9,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':-456789.21},
                   {'id':10,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':11,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':12,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':-456789.21},
                   {'id':13,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':-456789.21},
                   {'id':14,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':456789.21},
                   {'id':15,'comprobante':'12345678912','tipo':'NC','fecha':'12/12/2014','vencimiento':'15/12/2014','monto': 12345.11,'saldo':0.00}
            ],
          }
        },


      computed: {
  
        // items () {
        //   return this.$store.state.pedido.descuentos;
        // },
      },


      methods: {

        onKeyDownHandler() {

        },

        checkAllEvent () {
          if (!this.checked)
          {
            this.checked = true
          }
          else
          {
            this.checked = false
          }
          this.$emit('checkAllItems', this.checked);
        },





        itemChecked(id) {
          if (this.comprobChecked.includes(id))
          {
            var index = this.comprobChecked.indexOf(id);
            if (index > -1) 
            {
              this.comprobChecked.splice(index, 1);
            }
          }
          else
          {
            this.comprobChecked.push(id)
          }  
          console.log('>>>'+this.comprobChecked);
        },


        btnDelete() {

        },



        btnDownload() {

        },
      




      },

 



      mounted () {
        this.$store.commit('loader/stop')
      }

    }
    
  </script>
  
  
<style scoped>



  #listMenu-container {
   width: 100%;
   height: 60px; 
   display: flex;
   flex-direction:row; 
   align-items: center;
   background: #ffffff; 
  }

  #listMenu-containerL {
   width: 50%;
   display: flex;
   flex-direction:row; 
   justify-content: flex-start;    
   background: #ffffff; 
  }


  #busqueda{
  border-radius: 20px;  
  width: 150px;
  margin-left:25px;
  padding-left: 40px;
  height:20px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  color: #000000;
  outline: none;
  background: white url(/dist/icon-search.png) left no-repeat ;
  background-size: 15px 15px; 
  background-position: 10px;
  font-size: 12px;
  font-family: 'Rubik', sans-serif;
  }

  #listMenu-containerR {
   width: 50%;
   display: flex;
   flex-direction:row; 
   justify-content: flex-end;    
   background: #ffffff; 
  }

.textHeaderList{
  color:#656E76;
  font-size: 10px;
  font-weight: 500;
}


 #headerList-container {
   width: 650px;
   margin-left: 22px;
   height: 25px; 
   display: flex;
   flex-direction:row; 
   align-items: center;
   justify-content: center;
   background: #ffffff; 
  }



.checkContainer{
  display: flex;
  flex-direction:row; 
  align-items: center;
  justify-content: center;
}


 .icon{
   height: 25px;
   margin-right: 25px;
  }

 .icon:hover { cursor: pointer; }




  #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
  }

  #main-container{
   position: absolute;
   top: 55vh;
   left: 50%;
   transform: translate(-50%,-50%);
   width: 700px;
   height: 85vh;
  }

  #label-container{
   width: 700px;
   height: 10vh;
  }

  #label{
   color:#ffffff;
   font-size: 27px;
  }

  #container{
   width: 700px;
   height: 75vh;
   padding-top: 0px;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   background-color: #ffffff;
  }

  #list-container{
   width: 680px;
   margin-top: 10px;  
   height: 56vh;
   margin-left: auto;
   margin-right: auto;
   background: #ffffff;
   overflow: auto;
   display: flex;
   flex-direction:column; 
   align-items: center; 
  }


/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dddddd; 
    border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #cccccc; 
    border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #bbbbbb; 
}


  </style>


// WEBPACK FOOTER //
// src/components/views/cuentaCorriente/cuentaCorriente.vue